export const SNACKBAR = "SNACKBAR";
// Get user details from application storage
export const GET_USER = "GET_USER";
